import { Grid } from "@react-three/drei";

type AreaPortal = {
  key: "ClaudeMd" | "Memory" | "MCP" | "Skills";
  position: [number, number, number];
  color: string;
};

const AREA_PORTALS: ReadonlyArray<AreaPortal> = [
  { key: "ClaudeMd", position: [-15, 1.5, -15], color: "#7aa9ff" }, // NW
  { key: "Memory", position: [15, 1.5, -15], color: "#ffd17a" }, // NE
  { key: "MCP", position: [-15, 1.5, 15], color: "#7affc6" }, // SW
  { key: "Skills", position: [15, 1.5, 15], color: "#ff97c8" }, // SE
];

const TOOL_PLAZA_POSITION: [number, number, number] = [-18, 1.25, 0];
const EXPORT_ALTAR_POSITION: [number, number, number] = [0, 1, -10];

export function Hub() {
  return (
    <group>
      <Grid
        args={[60, 60]}
        cellColor="#3a3f55"
        sectionColor="#5a6080"
        sectionThickness={1.2}
        fadeDistance={50}
        infiniteGrid={false}
      />
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, -0.01, 0]} receiveShadow>
        <planeGeometry args={[60, 60]} />
        <meshStandardMaterial color="#1f2233" />
      </mesh>

      <mesh position={[0, 3.5, 0]} castShadow>
        <boxGeometry args={[2.4, 7, 2.4]} />
        <meshStandardMaterial color="#cdd2e6" />
      </mesh>
      <mesh position={[0, 7.4, 0]} castShadow>
        <coneGeometry args={[1.8, 1.8, 4]} />
        <meshStandardMaterial color="#a4abc8" />
      </mesh>

      {AREA_PORTALS.map((portal) => (
        <mesh key={portal.key} position={portal.position} castShadow>
          <boxGeometry args={[3, 3, 3]} />
          <meshStandardMaterial color={portal.color} />
        </mesh>
      ))}

      <mesh position={TOOL_PLAZA_POSITION} castShadow>
        <boxGeometry args={[3, 2.5, 6]} />
        <meshStandardMaterial color="#aebccf" />
      </mesh>

      <mesh position={EXPORT_ALTAR_POSITION} castShadow>
        <cylinderGeometry args={[1.4, 1.6, 2, 8]} />
        <meshStandardMaterial color="#dfc97a" emissive="#a07b1c" emissiveIntensity={0.2} />
      </mesh>
    </group>
  );
}
